/**
 * Cart Drawer Intercept — network-based (Zepto-safe)
 * Does NOT touch the add-to-cart button, so Zepto Product Personalizer
 * keeps its own click handler and personalization is preserved.
 * Watches /cart/add.js and opens the AI cart drawer once the add succeeds.
 *
 * assets/cart-drawer-intercept.js
 * <script src="{{ 'cart-drawer-intercept.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';
  var V = '[ATC]';
  var MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?/i;
  var IS_ADD   = /\/cart\/add/i;

  // The add happens over the network, so by the time the drawer opens there is
  // nothing tying it back to the control the customer used. Remember that
  // control here and hand it to the drawer, which returns focus to it on
  // close. document.activeElement alone is not enough — Safari does not focus
  // a <button> when it is clicked.
  var lastTrigger = null;
  document.addEventListener('pointerdown', function (e) {
    var el = e.target && e.target.closest
      ? e.target.closest('button, [type="submit"], a[href], [role="button"]')
      : null;
    if (el) lastTrigger = el;
  }, true);

  function refreshAndMaybeOpen(url) {
    document.dispatchEvent(new CustomEvent('cart:updated'));

    var d = window.cartDrawer;
    if (d && typeof d.fetchCart === 'function') d.fetchCart();

    if (IS_ADD.test(url)) {
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer(lastTrigger);
      } else if (d && typeof d.open === 'function') {
        d.open(lastTrigger);
      } else {
        console.warn(V, 'no cart drawer opener available');
      }
    }
  }

  function handle(url) {
    // delay lets Zepto's Cart Transform finish writing line-item
    // properties/pricing before we re-read /cart.js
    setTimeout(function () { refreshAndMaybeOpen(url); }, 80);
  }

  // --- fetch() ---
  if (window.fetch && !window.__atcFetchPatched) {
    window.__atcFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return origFetch.apply(this, arguments).then(function (res) {
        try { if (MUTATION.test(url) && res.ok) handle(url); } catch (e) {}
        return res;
      });
    };
    console.log(V, 'fetch patched');
  }

  // --- XMLHttpRequest (jQuery / Zepto AJAX) ---
  if (window.XMLHttpRequest && !window.__atcXHRPatched) {
    window.__atcXHRPatched = true;
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, url) {
      this.__atcUrl = url || '';
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (MUTATION.test(xhr.__atcUrl || '')) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) handle(xhr.__atcUrl);
        });
      }
      return origSend.apply(this, arguments);
    };
    console.log(V, 'XHR patched');
  }
})();